<template>
    <div class="agreement">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>大客户管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>公司管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.name" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    :height="tableConfig.height"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column prop="code" label="公司代码" width="auto" min-width="100"></el-table-column>
                    <el-table-column prop="name" label="公司名称" width="auto" min-width="200"></el-table-column>
                    <el-table-column prop="businessLicense" label="营业执照号" width="auto"></el-table-column>
                    <el-table-column prop="ownerDepartment" label="所属部门" width="auto"></el-table-column>
                    <el-table-column prop="cs1" label="客户经理" width="auto"></el-table-column>
                    <el-table-column prop="cs2" label="客户经理" width="auto"></el-table-column>
                    <el-table-column prop="purchaserComputePriceWithUntaxed" label="总价结算方式(采购方)" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="!scope.row.purchaserComputePriceWithUntaxed" size="mini">含税</el-tag>
                            <el-tag v-if="scope.row.purchaserComputePriceWithUntaxed" size="mini" type="success">未税</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierComputePriceWithUntaxed" label="总价结算方式(供应商)" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="!scope.row.supplierComputePriceWithUntaxed" size="mini">含税</el-tag>
                            <el-tag v-if="scope.row.supplierComputePriceWithUntaxed" size="mini" type="success">未税</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="platform" label="平台公司" width="auto" align="center" min-width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.platform" size="mini">是</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="right" >
                        <template slot="header">
                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">

                            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)" style="color:red;">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination v-if="total > 0"
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="公司信息" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px" size="mini">
                <el-form-item label="公司代码" prop="code">
                    <el-input v-model="editForm.code" placeholder="请输入公司代码" clearable></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入公司名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="所属部门" prop="department">
                    <el-select v-model="editForm.ownerDepartmentId" placeholder="请选择" style="width: 100%" clearable>
                        <el-option-group
                        v-for="company in platformCompanyDepartments"
                        :key="company.companyId"
                        :label="company.name">
                        <el-option
                            v-for="department in company.children"
                            :key="department.departmentId"
                            :label="department.name"
                            :value="department.departmentId">
                        </el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户经理" prop="csId1">
                    <el-select v-model="editForm.csId1" filterable placeholder="请选择客户经理" clearable>
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户经理" prop="csId2">
                    <el-select v-model="editForm.csId2" filterable placeholder="请选择客户经理" clearable>
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="营业执照号">
                    <el-input v-model="editForm.businessLicense" placeholder="请输入营业执照号" clearable></el-input>
                </el-form-item>
                <div>总价计算基准</div>
                <el-row>
                    <el-col span="12">
                        <el-form-item label="做为采购方">
                            <el-switch v-model="editForm.purchaserComputePriceWithUntaxed" active-text="未税" inactive-text="含税"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col span="12">
                        <el-form-item label="做为供应商">
                            <el-switch v-model="editForm.supplierComputePriceWithUntaxed" active-text="未税" inactive-text="含税"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="平台公司">
                    <el-switch v-model="editForm.platform">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmit" size="mini" :loading="saveLoading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="发票信息" :visible.sync="editInvoiceDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editInvoiceForm" :model="editInvoiceForm" :rules="rules" label-width="100px">
                <el-form-item label="发票类型" prop="type">
                    <el-select v-model="editInvoiceForm.type" placeholder="请选择发票类型" clearable>
                        <el-option value="0" key="0" label="不开发票"/>
                        <el-option value="1" key="1" label="普票"/>
                        <el-option value="2" key="2" label="增值税发票"/>
                        <el-option value="3" key="3" label="电子普票"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司税号" prop="companyTaxNo">
                    <el-input v-model="editInvoiceForm.companyTaxNo" placeholder="请输入税号" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户银行" prop="bankName">
                    <el-input v-model="editInvoiceForm.bankName" placeholder="请输入开户银行" clearable></el-input>
                </el-form-item>
                <el-form-item label="银行账号" prop="bankAccount">
                    <el-input v-model="editInvoiceForm.bankAccount" placeholder="请输入银行账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="注册电话" prop="registeredTel">
                    <el-input v-model="editInvoiceForm.registeredTel" placeholder="请输入注册电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="注册地址" prop="registeredAddress">
                    <el-input v-model="editInvoiceForm.registeredAddress" placeholder="请输入注册地址" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editInvoiceDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleEditInvoice">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                name: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            fileList: [],
            editForm: {
                id: "",
                code: "",
                name: "",
                businessLicense: "",
                ownerDepartmentId: "",
                csId1: "",
                csId2: "",
                purchaserComputePriceWithUntaxed: false,
                supplierComputePriceWithUntaxed: false,
                platform: false,
            },
            editInvoiceDialogVisible: false,
            editInvoiceForm: {
                id: "",
                companyId: "",
                type: "0",
                companyTaxNo: "",
                bankName: "",
                bankAccount: "",
                registeredTel: "",
                registeredAddress: "",
            },
            options: [],
            platformCompanyDepartments: [],
            saveLoading: false,
            rules: {
                code: [
                    { required: true, message: '请输入公司代码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                ownerDepartmentId: [
                    { required: true, message: '请选择所属部门', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择发票类型', trigger: 'blur' }
                ],
                companyTaxNo: [
                    { required: true, message: '请输入公司税号', trigger: 'blur' }
                ],
                bankName: [
                    { required: true, message: '请输入开户银行', trigger: 'blur' }
                ],
                bankAccount: [
                    { required: true, message: '请输入银行账号', trigger: 'blur' }
                ],
                registeredTel: [
                    { required: true, message: '请输入注册电话', trigger: 'blur' }
                ],
                registeredAddress: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            let company = {
            };
            if (this.searchForm.name != "") {
                company["name"] = this.searchForm.name;
            }
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/company/search", {
                cond: company,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content.map(one => {
                        if (one.csId1) {
                            for (let i = 0; i < _this.options.length; i++) {
                                if (_this.options[i].id === one.csId1) {
                                    one['cs1'] = _this.options[i].name;
                                    break;
                                }
                            }
                        }
                        if (one.csId2) {
                            for (let i = 0; i < _this.options.length; i++) {
                                if (_this.options[i].id === one.csId2) {
                                    one['cs2'] = _this.options[i].name;
                                    break;
                                }
                            }
                        }
                        return one;
                    });
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
            });
        },
        handleCreate() {
            this.editForm.id = "";
            this.editForm.code = "";
            this.editForm.name = "";
            this.editForm.businessLicense = "";
            this.editForm.ownerDepartmentId = "";
            this.editForm.csId1 = "";
            this.editForm.csId2 = "";
            this.editForm.purchaserComputePriceWithUntaxed = false;
            this.editForm.supplierComputePriceWithUntaxed = false;
            this.editForm.platform = false;
            this.editDialogVisible = true;
            this.saveLoading = false;
        },
        onSubmit() {
            let _this = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    _this.saveLoading = true;
                    this.$axios.post("/admin/company/save", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        }).finally(() => {
                            _this.saveLoading = false;
                        });
                }
            })
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.code = row.code;
            this.editForm.name = row.name;
            this.editForm.businessLicense = row.businessLicense;
            this.editForm.ownerDepartmentId = row.ownerDepartmentId;
            this.editForm.csId1 = row.csId1;
            this.editForm.csId2 = row.csId2;
            this.editForm.purchaserComputePriceWithUntaxed = row.purchaserComputePriceWithUntaxed
            this.editForm.supplierComputePriceWithUntaxed = row.supplierComputePriceWithUntaxed
            this.editForm.platform = row.platform;
            this.editDialogVisible = true;
            this.saveLoading = false;
        },
        handleUpload(index, row) {
            this.editForm.id = row.id;
            this.uploadDialogVisible = true;
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除用户【' + row.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/company/delete/" + row.id)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '数据删除成功',
                                type: 'success'
                            });
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        handleShowInvoiceDialog(index, row) {
            const that = this;
            this.$axios.get("/admin/company/getInvoice/" + row.id)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status === 0) {
                    if(resp.data) {
                        that.editInvoiceForm = {...resp.data, type: resp.data.type + ""};
                    } else {
                        that.editInvoiceForm = {
                            companyId: row.id,
                            type: "0",
                            companyTaxNo: "",
                            bankName: "",
                            bankAccount: "",
                            registeredTel: "",
                            registeredAddress: "",
                        }
                    }
                    that.editInvoiceDialogVisible = true;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: "获取发票信息失败"
                    });
                }
            });
        },
        handleEditInvoice() {
            const that = this;
            this.$refs.editInvoiceForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/company/editInvoice", that.editInvoiceForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status === 0) {
                            // if(resp.header.data) {
                            //     that.editInvoiceForm = resp.header.data;
                            // } else {
                            //     that.editInvoiceForm = {
                            //         companyId: row.id,
                            //         type: 0,
                            //         companyTaxNo: "",
                            //         bankName: "",
                            //         bankAccount: "",
                            //         registeredTel: "",
                            //         registeredAddress: "",
                            //     }
                            // }
                            that.editInvoiceDialogVisible = false;
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed() {
        window.removeEventListener("resize", this.setTableHeight);
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        const that = this;
        this.$axios.post("/admin/rights/staff/list", { type: 1 })
            .then(function (response) {
                const resp = response.data;
                if (resp.header.status == 0) {
                    that.options = resp.data;
                    that.onSearch();
                }
            }).catch(function () {
            });
        this.$axios.get("/admin/company/platformCompanyDepartment")
            .then(function (response) {
                const resp = response.data;
                if (resp.header.status == 0) {
                    that.platformCompanyDepartments = resp.data;
                }
            }).catch(function () {
            });
    },
}
</script>
<style></style>
